import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_roen_3: FaireProductEntity = {
  token: "legacy_prod_roen-3",
  type: "product",
  name: "Casa Polanco",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/56884e66685193058ffed10b4132877eba11d2a0013a35e2fa68ec6fad9c8ed6.webp",
  priceDollars: 19,
  msrpDollars: 38,
  freeShipping: true,
  brandAvatarUrl: "/images/ROEN/Brand%20Page/roen-avatar.webp",
  weight: 0.5,
  dimensions: {
    width: 3,
    height: 4,
    depth: 2,
  },
  brandToken: "catalog_brand_roen",
  description: "Premium candle from ROEN.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["candles", "home fragrance", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
